import React from 'react';
import NavBarViewSwitcher from '../../common/NavBarViewSwitcher';
import { NavigationHeaderContainer, NavigationHeaderInnerHeading } from '../../common/NavigationHeader';
import useEmceeLinks from '../../hooks/useEmceeLinks';
const DiscoverHeader = props => {
  const {
    manageHome
  } = useEmceeLinks();
  return /*#__PURE__*/React.createElement(NavigationHeaderContainer, null, /*#__PURE__*/React.createElement(NavigationHeaderInnerHeading, null, "Discover apps and integrations for ", props.hostConfig.name), props.hostConfig.supportsManage ? /*#__PURE__*/React.createElement(NavBarViewSwitcher, {
    history: props.history,
    href: manageHome.getRelative(),
    label: "Manage apps"
  }) : null);
};
export default DiscoverHeader;